const state = {
  // 先去localStorage中获取数据
  user: window.localStorage.getItem('user') && window.localStorage.getItem('user') !== '' && window.localStorage.getItem('user') !== 'null' ? JSON.parse(window.localStorage.getItem('user')) : {},
  token: window.localStorage.getItem('token') || '',
  auth: window.localStorage.getItem('auth') || ''
}

const mutations = {
  setUser (state, user) {
    if (user && user !== '') {
      // 将传递的数据先保存到localStorage中
      window.localStorage.setItem('user', JSON.stringify(user))
      // 之后才是修改state中的状态
      state.user = user
    } else {
      window.localStorage.setItem('user', null)
      window.localStorage.setItem('token', '')
      state.user = {}
      state.token = ''
      state.auth = ''
    }
  },
  setToken (state, token) {
    window.localStorage.setItem('token', token)
    state.token = token
  },
  setAuth (state, auth) {
    window.localStorage.setItem('auth', auth)
    state.auth = auth
  }
}

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: {}
}
